import { schema } from "normalizr";

const referredUser = new schema.Entity(
    "referredUsers",
    {},
    { idAttribute: "referredPublisher" }
);

export const referredUserList = new schema.Array(referredUser);
